// Máscara WhatsApp - +55 (11) 99999-9999
document.addEventListener('DOMContentLoaded', function () {
  const whatsappInput = document.getElementById('customer_whatsapp');
  if (!whatsappInput) return;

  const form = whatsappInput.closest('form');

  whatsappInput.addEventListener('keydown', function (e) {
    if (
      [46, 8, 9, 27, 13].includes(e.keyCode) ||
      (e.keyCode === 65 && e.ctrlKey) ||
      (e.keyCode === 67 && e.ctrlKey) ||
      (e.keyCode === 86 && e.ctrlKey) ||
      (e.keyCode === 88 && e.ctrlKey) ||
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) return;

    if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  });

  whatsappInput.addEventListener('input', function (e) {
    let value = e.target.value.replace(/\D/g, '');

    if (value.length > 0 && !value.startsWith('55')) {
      value = '55' + value;
    }

    value = value.slice(0, 13);

    let formatted = '';

    if (value.length <= 2) {
      formatted = '+' + value;
    } else if (value.length <= 4) {
      formatted = '+' + value.slice(0, 2) + ' (' + value.slice(2);
    } else if (value.length <= 9) {
      formatted = '+' + value.slice(0, 2) + ' (' + value.slice(2, 4) + ') ' + value.slice(4);
    } else {
      formatted = '+' + value.slice(0, 2) + ' (' + value.slice(2, 4) + ') ' +
                  value.slice(4, 9) + '-' + value.slice(9);
    }

    e.target.value = formatted;
  });

  form.addEventListener('submit', function (e) {
    const raw = whatsappInput.value.replace(/\D/g, '');

    if (raw.length !== 13 || !raw.startsWith('55')) {
      e.preventDefault();
      alert('Informe um WhatsApp válido no formato +55 (11) 99999-9999');
      whatsappInput.focus();
      return;
    }

    // 🔥 normaliza antes de enviar para o Shopify
    whatsappInput.value = '+' + raw;
  });

  whatsappInput.addEventListener('paste', function (e) {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData('text');
    whatsappInput.value = pasted.replace(/\D/g, '');
    whatsappInput.dispatchEvent(new Event('input', { bubbles: true }));
  });
});
